import { Injectable, inject } from '@angular/core';
import { EntityItemsRequest, EntityItemsResponse, NotificationCqrsActions, ProjectedNotification } from '@jms/model';
import { InboxRoomConnection, InboxRoomService } from '../../shared/services/inbox.room.service';

@Injectable({ providedIn: 'root' })
export class InboxNotificationSocketService {

    private readonly inboxRoom = inject(InboxRoomService);
    public readonly events$ = this.inboxRoom.events$;

    public get room(): InboxRoomConnection | null {

        return this.inboxRoom.room;
    }

    public getItems(request: EntityItemsRequest): Promise<EntityItemsResponse<ProjectedNotification>> {

        return this.inboxRoom.dispatch<EntityItemsResponse<ProjectedNotification>>(NotificationCqrsActions.getItems, { request });
    }

    public getById(notificationId: string): Promise<ProjectedNotification | null> {

        return this.inboxRoom.dispatch<ProjectedNotification | null>(NotificationCqrsActions.getById, { notificationId });
    }

    public getUnreadCount(): Promise<number> {

        return this.inboxRoom.dispatch<number>(NotificationCqrsActions.getUnreadCount, {});
    }

    public markAsRead(notificationIds: string[]): Promise<ProjectedNotification[]> {

        return this.inboxRoom.dispatch<ProjectedNotification[]>(NotificationCqrsActions.markAsRead, { notificationIds });
    }

    public markAsUnread(notificationIds: string[]): Promise<ProjectedNotification[]> {

        return this.inboxRoom.dispatch<ProjectedNotification[]>(NotificationCqrsActions.markAsUnread, { notificationIds });
    }

    public markAllAsRead(): Promise<{ updatedCount: number }> {

        return this.inboxRoom.dispatch<{ updatedCount: number }>(NotificationCqrsActions.markAllAsRead, {});
    }

    public markAllAsUnread(): Promise<{ updatedCount: number }> {

        return this.inboxRoom.dispatch<{ updatedCount: number }>(NotificationCqrsActions.markAllAsUnread, {});
    }

    public snooze(notificationIds: string[], snoozedUntil: Date): Promise<ProjectedNotification[]> {

        return this.inboxRoom.dispatch<ProjectedNotification[]>(NotificationCqrsActions.snooze, { notificationIds, snoozedUntil });
    }

    public unsnooze(notificationIds: string[]): Promise<ProjectedNotification[]> {

        return this.inboxRoom.dispatch<ProjectedNotification[]>(NotificationCqrsActions.unsnooze, { notificationIds });
    }

    public delete(notificationIds: string[]): Promise<void> {

        return this.inboxRoom.dispatch<void>(NotificationCqrsActions.delete, { notificationIds });
    }

    public deleteAll(onlyRead?: boolean): Promise<{ deletedCount: number }> {

        return this.inboxRoom.dispatch<{ deletedCount: number }>(NotificationCqrsActions.deleteAll, { onlyRead });
    }
}
